export default __webpack_public_path__ + "static/media/calendly-blue.16417f30.svg";